import React from "react";
import styles from "./styles/style.module.scss";
import { Col, Container, Row } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import Link from "next/link";
import { useRouter } from "next/router";
import HumanSvg from "./assets/human.svg";
import WhatsappIcon from "./assets/whatsapp.svg";
import CallIcon from "./assets/call.svg";
import Image from "next/image";
import { buildWhatsAppUrl } from "../../../utils/whatsapp.mjs";

const ContactNumbers = ({ initData }) => {
    const { locale } = useRouter();

    // const userPhones = [
    //     {
    //         name: {
    //             en: "Mohamed Abdelrahman Ahmed Mohamed",
    //             ar: "محمد عبد الرحمن احمد محمد"
    //         },
    //         number: "01000014330",
    //     },
    //     {
    //         name: {
    //             en: "Mohamed",
    //             ar: "محمد"
    //         },
    //         number: "01000014330",
    //     },
    //     {
    //         name: {
    //             en: "Mohamed",
    //             ar: "محمد"
    //         },
    //         number: "01000014330",
    //     },
    // ]
    const userPhones = initData?.siteInfo?.userPhones;
    return (
        <div className={styles["contact-nums"]}>
            <Container className="pb-5">
                <h2 className="fw-bold mb-5">
                    <FormattedMessage id="contact-nums" />
                </h2>
                <Row className="contacts-container gy-4">
                    {userPhones?.map((phone, index) => {
                        return (
                            <Col
                                xxl={4}
                                xl={4}
                                lg={4}
                                md={6}
                                sm={12}
                                xs={12}
                                
                                key={index}
                            >
                                <div key={index} className="card-item">
                                    <div className="contact-icon">
                                        <Image
                                            src={HumanSvg}
                                            width={30}
                                            height={30}
                                            alt="contact-icon"
                                        />
                                    </div>
                                    <div className="contact-name">
                                        {phone?.name?.[locale]}
                                    </div>
                                    <div className="contact-nums">
                                        <Link
                                            href={buildWhatsAppUrl(phone.number)}
                                            legacyBehavior
                                        >
                                            <div className="icon-container">
                                                <a
                                                    className="whatsapp"
                                                    aria-label="whatsapp-link"
                                                    href="!#"
                                                >
                                                    <Image
                                                        src={WhatsappIcon}
                                                        width={30}
                                                        height={30}
                                                        alt="whatsapp link"
                                                    />
                                                </a>
                                            </div>
                                        </Link>
                                        <Link
                                            href={`tel:${phone.number}`}
                                            legacyBehavior
                                        >
                                            <div className="icon-container">
                                                <a
                                                    className="call"
                                                    aria-label="call-link"
                                                    href="!#"
                                                >
                                                    <Image
                                                        src={CallIcon}
                                                        width={30}
                                                        height={30}
                                                        alt="call-link"
                                                    />
                                                </a>
                                            </div>
                                        </Link>
                                    </div>
                                </div>
                            </Col>
                        );
                    })}
                </Row>
            </Container>
        </div>
    );
};

export default ContactNumbers;
